import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow_down",
  "use": "arrow_down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow_down\">\r\n    <path d=\"M80.375962 271.537646h894.886512l-447.443256 447.443256-447.443256-447.443256z\" p-id=\"9048\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol